import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Button } from '@/ui';
import { TabPane } from './TabPane';
import _ from 'lodash';
import { useHandlers } from '../../views/OfferBlocks/queries';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import {
  renderComboBox,
  renderField,
  renderPrePingMethod,
  renderToggleSwitch,
  textarea,
} from '../FormFields/reduxFormRenderers';
import { NumberField } from './index';
import InternalPrePings from './InternalPrePings';
import { useOfferSummaries } from '../../views/Offers/queries';
import { useOfferActionsTable } from '../../views/OfferActions/queries';
import { getOfferSelector } from '../../reducers/OfferTitleReducer';

export const PrePingPane = ({ criteriaType }) => {
  const [httpIsHidden, setHttpIsHidden] = useState(true);
  const { data: offers, isLoading: loadingOffers, error: offerLoadingError } = useOfferSummaries();
  const { data: offerActions, isLoading: offerActionsLoading, error: offerActionsError } = useOfferActionsTable();

  const { data: handlers } = useHandlers(true, (data) => _.orderBy(data, ['name'], ['asc']));
  const prePingMethod = useSelector((state) => getOfferSelector()(state, 'prePingMethod'));

  if (offerLoadingError || offerActionsError) {
    return <div>Error loading offers or offer actions</div>;
  }

  return (
    <TabPane tabId='Pre-ping'>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }} className='ppLeft'>
          <Typography variant='h5'>Internal Pre-Ping</Typography>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ py: 1 }}>
            <InternalPrePings
              criteriaType={criteriaType}
              offers={offers}
              offerActions={offerActions}
              loadingOffers={loadingOffers}
              offerActionsLoading={offerActionsLoading}
            />
          </Box>
        </Grid>
        <Grid size='grow'>
          <div>
            <Typography variant='h5'>External Pre-Ping</Typography>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
              <FormLabel htmlFor='prePingResult' component='span'>
                Pre-Ping Result Stored
              </FormLabel>
              <Field name='prePingResultSessionCapture' component={renderToggleSwitch} id='prePingResult' />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
              <FormLabel htmlFor='externalPrePingProcessingEnabled' component='span'>
                Advanced Pre Ping Enabled
              </FormLabel>
              <Field
                name='externalPrePingProcessingEnabled'
                component={renderToggleSwitch}
                id='externalPrePingProcessingEnabled'
              />
            </Box>
            <Grid container spacing={2}>
              <Grid size='grow'>
                <Field name='prePingMethod' component={renderPrePingMethod} type='select' label='Pre Ping Method' />
              </Grid>
              <Grid size='grow'>
                <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                  Handler
                </FormLabel>
                <Field
                  name='prePingHandlerId'
                  component={renderComboBox}
                  data={handlers}
                  valueField='id'
                  textField='name'
                />
              </Grid>
            </Grid>
            {prePingMethod !== 'NONE' && (
              <Box sx={{ mt: 2 }}>
                <Field name='prePing' type='text' component={renderField} label='URL' />
                {(prePingMethod === 'POST' || prePingMethod === 'JSON' || prePingMethod === 'XML') && (
                  <Box sx={{ mt: 2 }}>
                    <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                      Body
                    </FormLabel>
                    <Field name='prePingBody' component={textarea} type='text' />
                  </Box>
                )}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 2 }}>
                  <Button onClick={() => setHttpIsHidden(!httpIsHidden)}>
                    <em>advanced settings</em>
                  </Button>
                </Box>
                {!httpIsHidden && (
                  <div>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, lg: 3 }}>
                        <Field name='prePingTimeout' component={NumberField} label='Timeout (ms)' />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, lg: 4 }}>
                        <Field name='prePingHeader1' component={renderField} type='text' label='Header 1' />
                      </Grid>
                      <Grid size={{ xs: 12, lg: 4 }}>
                        <Field name='prePingHeader2' component={renderField} type='text' label='Header 2' />
                      </Grid>
                      <Grid size={{ xs: 12, lg: 4 }}>
                        <Field name='prePingHeader3' component={renderField} type='text' label='Header 3' />
                      </Grid>
                    </Grid>
                    <Box sx={{ mt: 2 }}>
                      <Field
                        name='prePingCustomHttpStatus'
                        component={renderField}
                        type='text'
                        label='Other HTTP Status'
                      />
                    </Box>
                  </div>
                )}
              </Box>
            )}
          </div>
        </Grid>
      </Grid>
    </TabPane>
  );
};
